import type { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import {
  Button,
  ModalHead,
  Prompt,
  PromptActions,
  PromptBody,
  StackList,
  StackListItem,
  StackListValue,
  Title,
} from 'admination-react'
import type { GevaKlettFehlerZeile, NameAbweichung } from '../../api/gevaKlett'

export function fehlerZeileText(f: GevaKlettFehlerZeile, t: TFunction<'vergabeStaff'>): string {
  const parts: string[] = []
  if (f.datei != null) parts.push(f.datei)
  if (f.seite != null) parts.push(t('gevaKlett.fehlerSeite', { n: f.seite }))
  if (f.zeile != null) parts.push(t('gevaKlett.fehlerZeile', { n: f.zeile }))
  if (f.feld != null) parts.push(f.feld)
  parts.push(f.grund)
  return parts.join(' · ')
}

export function GevaKlettFehlerPrompt({
  meldung,
  fehler,
  onClose,
}: {
  meldung: string
  fehler: GevaKlettFehlerZeile[]
  onClose: () => void
}) {
  const { t } = useTranslation('vergabeStaff')
  return (
    <Prompt aria-label={t('gevaKlett.refusedTitle')} onEscape={onClose} topbar={<ModalHead onClose={onClose} closeLabel={t('gevaKlett.close')} />}>
      <PromptBody>
        <Title as="h3">{t('gevaKlett.refusedTitle')}</Title>
        <p>{meldung}</p>
        <StackList>
          {fehler.map((f, i) => (
            <StackListItem key={i}>{fehlerZeileText(f, t)}</StackListItem>
          ))}
        </StackList>
      </PromptBody>
    </Prompt>
  )
}

export function NameAbweichendPrompt({
  abweichung,
  onSpeichern,
  onAbbrechen,
}: {
  abweichung: NameAbweichung
  onSpeichern: () => void
  onAbbrechen: () => void
}) {
  const { t } = useTranslation('vergabeStaff')
  return (
    <Prompt aria-label={t('gevaKlett.name.title')} topbar={<ModalHead onClose={onAbbrechen} closeLabel={t('gevaKlett.close')} />} onEscape={onAbbrechen} cardRole="alertdialog" data-testid="name-abweichend">
      <PromptBody>
        <Title as="h3">{t('gevaKlett.name.title')}</Title>
        <p>{t('gevaKlett.name.text')}</p>
        <StackList>
          <StackListItem end={<StackListValue data-testid="name-gelesen">{abweichung.gelesen}</StackListValue>}>
            {t('gevaKlett.name.gelesen')}
          </StackListItem>
          <StackListItem
            end={<StackListValue data-testid="name-teilnehmende">{abweichung.teilnehmende}</StackListValue>}
          >
            {t('gevaKlett.name.teilnehmende')}
          </StackListItem>
        </StackList>
      </PromptBody>
      <PromptActions>
        <Button data-testid="name-abbrechen" onClick={onAbbrechen}>
          {t('gevaKlett.name.abbrechen')}
        </Button>
        <Button variant="primary" data-testid="name-trotzdem-speichern" onClick={onSpeichern}>
          {t('gevaKlett.name.speichern')}
        </Button>
      </PromptActions>
    </Prompt>
  )
}
